const Button = {
  sizes: {
    md: {
      padding: '6px 12px',
      height: 'auto',
      minHeight: '34px',
      fontSize: '14px',
    },
  },
  baseStyle: {
    fontWeight: '400',
    lineHeight: '20px',
    borderRadius: '3px',
    _focus: {
      boxShadow: 'none',
    },
  },
  variants: {
    outline: {
      _hover: {
        backgroundColor: 'inherit',
      },
    },
    cancel: {
      color: '#333333',
      border: '1px solid #CCCCCC',
      backgroundColor: '#ffffff',
      _hover: {
        borderColor: '#333333',
      },
    },
    fill: {
      backgroundColor: '#BB9D79',
      color: '#ffffff',
      border: '1px solid #BB9D79',
      _hover: {
        backgroundColor: '#BB9D79',
        borderColor: '#BB9D79',
      },
    },
    fillSuccess: {
      backgroundColor: '#5CB85C',
      border: '1px solid #4CAE4C',
      color: '#ffffff',
      _hover: {
        backgroundColor: '#449D44',
        borderColor: '#398439',
        _disabled: {
          backgroundColor: 'rgba(92, 184, 92, 0.65)',
          borderColor: 'rgba(76, 174, 76, 0.65)',
        },
      },
      _disabled: {
        backgroundColor: 'rgba(92, 184, 92, 0.65)',
        borderColor: 'rgba(76, 174, 76, 0.65)',
      },
    },
    listMore: {
      color: '#FFF',
      backgroundColor: '#337ab7',
      border: '1px solid #2e6da4',
      fontWeight: 'none',
      lineHeight: 'initial',
      _hover: {
        color: 'var(--member-center-button-list-more-hover-color, #FFF)',
        backgroundColor:
          'var(--member-center-button-list-more-hover-background-color, #286090)',
        borderColor: '#204d74',
      },
    },
    textButton: {
      padding: 0,
      color: '#3493fb',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      minHeight: 'auto',
      _hover: {
        color: '#337AB7',
      },
    },
    underlineText: {
      padding: 0,
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '28px',
      textDecoration: 'underline',
      color: '#333333',
      _hover: {
        color: '#666666',
      },
    },
    default: {
      minWidth: '100px',
      borderRadius: '3px',
      fontSize: 'calc(14px * var(--font-size-paragraph, 1))',
      fontWeight: 'none',
      lineHeight: 'initial',
      color: 'var(--primary-text, #fff)',
      borderColor: 'var(--primary-background, #111)',
      backgroundColor: 'var(--primary-background, #333)',
      _hover: {
        color: 'var(--primary-background, #FFF)',
        backgroundColor: 'var(--page-background, rgba(51,51,51,0.95))',
        border: '1px solid var(--primary-background, #222)',
      },
    },
    deleteIcon: {
      padding: 0,
      color: '#999999',
      fontSize: '12px',
      _hover: {
        color: '#999999',
      },
    },
    closeModal: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '14px',
      padding: 0,
      minHeight: 'auto',
      minWidth: 'auto',
      _hover: {
        color: '#333333',
      },
    },
    hidden: {
      display: 'none',
    },
    inheritTextButton: {
      color: 'inherit',
      backgroundColor: 'inherit',
      border: '0',
      padding: 0,
      minHeight: 'auto',
      _hover: {
        color: 'inherit',
        backgroundColor: 'inherit',
        border: '0',
      },
    },
  },
};

export default Button;
